"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";

export default function Issues() {
  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      spaceBetween={12}
      slidesPerView="auto"
      loop
      slidesOffsetBefore={24}
    >
      {[
        {
          title: "Gimbal and camera malfunction",
          image: "Gimbal and camera malfunction.png",
        },
        {
          title: "IMU and compass calibration errors",
          image: "IMU and compass calibration errors.png",
        },
        {
          title: "Battery and power-related issues",
          image: "Battery and power-related issues.png",
        },
        {
          title: "Vision and obstacle avoidance sensor faults",
          image: "Vision and obstacle avoidance sensor faults.png",
        },
        {
          title: "Motor overheating and propulsion issues",
          image: "Motor overheating and propulsion issues.png",
        },
      ].map((v, i) => (
        <SwiperSlide key={i} className="pb-8 max-w-64">
          <div className="bg-white rounded-xl p-5 shadow-md hover:shadow-xl duration-300 transition-shadow">
            <Image
              src={`/images/drone-repair/${v.image}`}
              alt={v.title}
              width={64}
              height={64}
              className="size-12 mb-2"
            />
            <p className="font-medium">{v.title}</p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
